import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propArrayShape, propBool, propFunc, propId, propStr, propValidate, } from '../../../../helpers/custom-prop-types';
import PlainSelect from '../PlainSelect';
const SelectField = ({ className, disabled, name, onChange, options, validate, }) => (_jsx(Field, { className: className, component: PlainSelect, disabled: disabled, name: name, options: options, validate: validate, wrapOnChange: onChange }));
SelectField.propTypes = {
    className: propStr(),
    disabled: propBool(),
    name: propStr().isRequired,
    onChange: propFunc(),
    options: propArrayShape({
        label: propStr().isRequired,
        value: propId().isRequired,
    }).isRequired,
    validate: propValidate(),
};
SelectField.defaultProps = {
    className: 'form-solution-select',
    disabled: false,
    onChange: undefined,
    validate: [],
};
export default SelectField;
